// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610191519/js/" + chunkId + "." + {"44":"2b3bace0","225":"bef8c7b7","481":"62c7b7d6","486":"4e892566","770":"f6d089de"}[chunkId] + ".0.3929438788166344.chunk.js";
};